import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../components/header_home'
import MissionCard from '../../components/mission_card'
import Tour from '../../components/tour'
import { useGame, useTour, usePage, useGameWrapper } from '../../contexts'
import { Wrapper, MissionContainer, MissionCards, MissionWrapper } from './styles'
import { MissionModel } from '../../../domain/model/mission.model'
import { getTeam } from '../../utils/team_helpers'
import { groupIsComplete, orderByPosition } from '../../utils/mission_helpers'
import { getLocalStorage, removeLocalStorage } from '../../utils/storage_helpers'
import { makeLoadBySlug } from '../../../main/usecases/game/load-games-factory'
import { GameModel } from '../../../domain/model/game.model'
import Loading from '../../components/loadings/simple'
import { t } from '../../adapters/translate/translate'
import { isPwa } from '../../utils/general'
import { GameState } from '../../../domain/enum/game-state.enum'

export type IMissionProps = {
  id: string;
  name: string;
  type: 'done-group' | 'done' | 'current' | 'blocked';
  hasGift?: boolean;
  points?: number;
}

const Home = () => {
  const [missions, setMissions] = useState<IMissionProps[]|any>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const team = getTeam()

  const navigate = useNavigate()
  const { game, loadPoints } = useGame()
  const { handleToggleCurrentMission } = useGameWrapper()
  const { toggleHeaderConfig } = usePage()
  const { handleToggleTour, currentStep, tourWasCompleted, showInstructions, isOpen: tourIsOpened } = useTour()

  function handleGoToMission (mission:MissionModel) {
    handleToggleCurrentMission(mission)
    navigate('/mission')
  }

  function focusCurrentMission () {
    setTimeout(() => {
      const currentMissionEl = document.querySelector('[type=current].not-first')
      if (currentMissionEl) currentMissionEl.scrollIntoView()
    }, 200)
  }

  function addStatusInGameMissionsInterna () {
    const localAnswers = JSON.parse(getLocalStorage('localAnswers') || '[]')
    setMissions((state: MissionModel[]) => {
      return state.map((mission: MissionModel, idx: number) => {
        mission.status = idx === 0 ? 'current' : 'blocked'
        if (localAnswers.find((item:any) => item.uuid === mission.uuid)) mission.status = 'done-group'

        mission.childMissions = mission.childMissions.sort(orderByPosition).map((missionChild: MissionModel) => {
          missionChild.status = 'blocked'
          if (localAnswers.find((item:any) => item.uuid === missionChild.uuid)) mission.status = 'done'
          return missionChild
        }, [])

        return mission
      })
    })
  }

  async function loadPageSettings () {
    if (getLocalStorage('gameCode')) {
      const data: GameModel = await makeLoadBySlug().load(`/${getLocalStorage('gameCode')}?team=${team?.id}`)
      setMissions(data?.missions.sort(orderByPosition).filter((item: MissionModel) => item.isParent && item.type !== 'welcome' && item.type !== 'instructions'))
      redirectToGreetingsPage()
      if (data.type === 'linear') {
        await loadPoints()
      }
      addStatusInGameMissionsInterna()
      toggleHeaderConfig({ type: 'title', title: getLocalStorage('gameTitle') || t('Game Journey'), teamName: getTeam()?.name })
      removeLocalStorage('currentMission')
      removeLocalStorage('currentParent')
      removeLocalStorage('currentChildren')
      if (tourWasCompleted) focusCurrentMission()
    } else {
      if (isPwa()) { // pwa e nao possui gameCode
        navigate('/login')
      } else { // esta no web e nao possui gameCode
        navigate('/game-not-found')
      }
    }
    setIsLoading(false)
  }

  function redirectToGreetingsPage () {
    const alreadyGoToGreetingsPage = getLocalStorage('greetings') || null
    if (!getTeam()?.team && !alreadyGoToGreetingsPage) {
      navigate('/greetings')
    }
  }

  function parentHandle (mission:MissionModel) {
    const childMission = mission?.childMissions.find((item:any) => !item.responded)
    if (!mission.responded) {
      handleGoToMission(mission)
      return
    }
    if (childMission) {
      handleGoToMission(childMission)
    }
  }

  useEffect(() => {
    loadPageSettings()
  }, [game])

  useEffect(() => {
    if (game.gameState !== GameState.APPROVAL) {
      const alreadyGoToGreetingsPage = getLocalStorage('greetings') || null
      if (!tourWasCompleted && alreadyGoToGreetingsPage && !isLoading && showInstructions) {
        handleToggleTour()
      }

      if (currentStep.className === 'tour-2') {
        toggleHeaderConfig({ type: 'timer' })
      }
      if (tourWasCompleted) {
        toggleHeaderConfig({ type: 'title', title: getLocalStorage('gameTitle') || t('Game Journey'), teamName: getTeam()?.name })
      }
    }
  }, [currentStep, tourWasCompleted, isLoading, showInstructions, game])

  return (
    <>
      <Wrapper>
        <Header />
        <MissionWrapper>
          <MissionContainer gameColor={game?.baseColor || '#fff'}>
          { isLoading
            ? <Loading />
            : (
                <MissionCards>
                  {missions.sort(orderByPosition).map((mission:any, idx:number) => {
                    let missionAction:any = () => {}
                    let type:any = mission.status

                    if (mission.status === 'current') {
                      missionAction = parentHandle
                    }

                    if (groupIsComplete(missions[idx - 1]) || missions[idx - 1]?.status === 'done-group') {
                      type = 'current'
                      missionAction = parentHandle
                    }

                    if (groupIsComplete(mission) || mission.status === 'done-group') {
                      missionAction = () => {}
                      type = 'done'
                    }

                    return (
                      <MissionCard
                        key={idx}
                        firstMission={idx === 0}
                        className={
                          (type === 'current' && currentStep.className === 'tour-1' && !tourWasCompleted
                            ? 'tour-1 '
                            : ''
                          ) + (idx !== 0 ? 'not-first' : '')
                        }
                        onAction={type === 'current' && !tourIsOpened ? missionAction : () => {}}
                        type={type}
                        points={mission.pointsIfCorrect}
                        mission={mission}
                        hideBar={idx === missions.length - 1 }
                      />
                    )
                  })}
                </MissionCards>
              )
          }
          </MissionContainer>
        </MissionWrapper>
        <Tour />
      </Wrapper>
    </>
  )
}

export default Home
